export default [
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 0,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "Bienvenu 🤗 Je vais vous poser quelques questions. Vos réponses vont me permettre d'élaborer l'entraînement qui vous correspond le mieux. A la fin du test, pas de note. On vous oriente vers votre parcours personnalisé.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 0,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Cliquez sur le bouton \"On y va\" quand vous êtes prêt !",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 0,
    "content_id": 2,
    "type": "button",
    "format": "text",
    "content": "On y va 🚀",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Dans la phrase suivante, qu’est-ce qui a été fait hier ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "C’est une photo d’un gâteau qui a été faite hier.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[une photo d’un gâteau||un gâteau ]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La phrase suivante est-elle complète ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Vous êtes tous témoins qu’il y a un instant, quand vous m’adressiez ces demandes qui, croyez-le bien, m’ont été bien cruelles.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 2,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Oui||Non]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Quelle partie de la phrase est remplaçable par “la”?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Marie donne sa glace à la fraise à la fille de la voisine.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 3,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[sa glace à la fraise||Marie||la fille de la voisine]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Quelle est la phrase qui contient une faute d’accord ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Le travail du metteur en scène, qui dirige les comédiens et les techniciens, prolonge celui de l’auteur.||La notion de « quatrième mur », mise en avant par le metteur en scène André Antoine, est due à Denis Diderot.||Tant que le théâtre obéit à des règles comme celle des trois unités et suivent des codes, le metteur en scène n’existe pas.]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Parmi les propositions suivantes, quelle est celle qui correspond bien à la description de l’épreuve de langue définie dans cette phrase ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pour l’oral de langue vivante, c’est l’une des notions qui sont étudiées pendant l’année qui est tirée au sort.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 5,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[On est interrogé sur plusieurs notions tirées au sort.||On tire au sort la notion qui est étudiée pendant l’année.||On est interrogé par tirage au sort sur l’une des notions étudiées pendant l’année.]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Pourquoi cette phrase ne pourrait-elle pas figurer telle quelle dans l’une de vos\ndissertations d’Histoire ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Prononcé le 30 mars 1947, moins de deux ans seulement après la fin de la guerre, ce discours commémorant un acte de Résistance que le général de Gaulle évoque dans les deux premières lignes du texte.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 6,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[parce qu’elle est trop longue||parce qu’elle est incomplète||parce qu’elle devrait commencer par le sujet de la phrase]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Réduisez au maximum la phrase suivante, en ne gardant que le verbe principal et son sujet.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Entre la double haie des magasins aux déballages qui broutaient l'asphalte, il dérivait dans la cohue des bobonnes attentives à l'appel d'un vendeur qui annonçait un rabais sur un produit de première nécessité, justement épuisé dans leur panoplie de femmes d'intérieur accomplies.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 7,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Un vendeur annonçait.||Il dérivait.||Les déballages broutaient.]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Simplifiez le sujet du @verbe@ pour passer à un verbe au singulier.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Mon ancienne affection, la connaissance que j'avais de sa droiture, son inintelligence politique et le peu d'importance de ses faits et gestes dans un domaine qui n'était pas le sien, m'@incitaient@ à l'indulgence en dépit de cette autre part, intransigeante, dure et bornée de moi-même.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 8,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[le peu d’importance||son inintelligence politique||mon ancienne affection]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Dans la phrase suivante, qui interdit à qui de faire des visites ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Je tiens à vous faire savoir que madame Frola, ma belle-mère, se serait présentée ici sans aucun doute avant que madame et mademoiselle eussent la bonté de l’honorer d’une visite, si je n’avais pas tout fait pour l’en empêcher, ne pouvant permettre en aucun cas qu’elle fasse des visites, ni qu’elle en reçoive.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "exercice": 9,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Madame Frola interdit à madame et mademoiselle de faire de visites.||Le narrateur (“je”) interdit à madame Frola de faire de visites.||Le narrateur (“je”) interdit à madame et mademoiselle de faire de visites.]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Voici un groupe nominal et deux propositions de décompositions de ce groupe. Choisissez laquelle de ces deux décompositions correspond le mieux au sens du groupe nominal. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Un invité de ma soeur vraiment très beau",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[[Un invité [de ma sœur vraiment très beau]]||[[Un invité de ma sœur] vraiment très beau ]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Une pièce de l'ordinateur qui doit être réparé",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[Une pièce de [l'ordinateur qui doit être réparé]]||[[Une pièce de l'ordinateur] qui doit être réparé]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Une solution du problème qui a été mise en œuvre",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[Une solution du [problème qui a été mise en œuvre]]||[[Une solution du problème] qui a été mise en œuvre]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L'élève de première guidé par le professeur",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[[L'élève de première] guidé par le professeur]||[[L'élève de première guidé] par le professeur]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Les personnes suivantes ayant participé à la réunion",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[Les personnes [suivantes ayant participé à la réunion]]||[[Les personnes suivantes] ayant participé à la réunion]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Tous les premiers mercredis du mois de l'année scolaire",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[[Tous les premiers mercredis du mois] de l'année scolaire]||[[Tous les premiers mercredis] du mois de l'année scolaire]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mon vélo rouge absolument magnifique",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[[Mon vélo rouge] absolument magnifique]||[[Mon vélo rouge absolument] magnifique]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mon vélo d'un rouge absolument magnifique",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[[Mon vélo d'un rouge] absolument magnifique]||[Mon vélo [d'un rouge absolument magnifique]]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La fille du voisin qui est chanteuse d’opéra",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[[La fille du voisin] qui est chanteuse d’opéra]||[La fille du voisin [qui est chanteuse d’opéra]]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La fille du voisin qui est chanteur d’opéra",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[[La fille du voisin] qui est chanteur d’opéra]||[La fille [du voisin qui est chanteur d’opéra]]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Choisissez le groupe de mots qui peut être remplacé par le pronom proposé.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 La petite fille a mangé trois glaces au chocolat.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Pronom : elle",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 1,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[la petite fille||trois glaces||trois glaces au chocolat||glaces au chocolat]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La petite fille a mangé trois glaces au chocolat.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : en",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 2,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[la petite fille||trois glaces||trois glaces au chocolat||glaces au chocolat]",
    "correct_answer": "4"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L'élève de première semble contente de son enseignante.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : elle",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 3,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[l'élève de première||de son enseignante||son enseignante||contente de son enseignante]",
    "correct_answer": "[1||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L'élève de première semble contente de son enseignante.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 4,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : le",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 4,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[l'élève de première||de son enseignante||son enseignante||contente de son enseignante]",
    "correct_answer": "4"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L'élève de première semble contente de son enseignante.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : en",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 5,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[l'élève de première||de son enseignante||son enseignante||contente de son enseignante]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Les chats de Pauline ont traversé les toits du quartier.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : les",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 6,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[les toits du quartier||du quartier||les chats de Pauline||les chats]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Les chats de Pauline ont traversé les toits du quartier.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : ils",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 7,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[les toits du quartier||du quartier||les chats de Pauline||les chats]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Les chats de Léo sont montés sur le toit.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : y",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 8,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[sur le toit||le toit||les chats de Léo||de Léo]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le professeur d'histoire prend le soleil dans la cour de récréation.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : y",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 9,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[dans la cour de récréation||dans la cour||le professeur d'histoire||la cour de récréation]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le professeur d'histoire prend le soleil dans la cour de récréation.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 10,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Pronom : il",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "exercice": 10,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[dans la cour de récréation||dans la cour||le professeur d'histoire||la cour de récréation]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Choisissez le groupe de mots que l’on peut déplacer dans la zone en blanc pour former une phrase correcte.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ que Manon a lu ce livre de science-fiction en trois jours.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Manon||en trois jours||ce livre de science-fiction||le livre]",
    "correct_answer": "[2||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ qui Paul a parlé à ses amis d'un voyage au Maroc.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[à ses amis||d'un voyage||Paul||au Maroc]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ que ma voisine m'a parlé hier d'un voyage au Maroc.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[hier||ma voisine||d'un voyage||d'un voyage au Maroc]",
    "correct_answer": "[1||4]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ que l'amie de Lisa a vu un film d'espionnage.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[vu||un film d'espionnage||Lisa||l'amie de Lisa]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ qui l'amie de Lisa a vu un film d'espionnage.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[vu||un film d'espionnage||Lisa||l'amie de Lisa]",
    "correct_answer": "4"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ que l'ami de Marwane a trouvé ce roman bizarre.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[ce roman||Marwane||bizarre||ce roman bizarre]",
    "correct_answer": "[1||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ que l'ami de Marwane a lu un roman bizarre.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[un roman||Marwane||bizarre||un roman bizarre]",
    "correct_answer": "4"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ qu’ Anton est devenu végétarien après son voyage de noces.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[de noces||après son voyage de noces||végétarien||devenu]",
    "correct_answer": "[2||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ qui Anton est devenu végétarien après son voyage de noces.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Anton||après son voyage de noces||de noces||devenu]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 C'est ___ que Liv cherche à tout prix à acheter une voiture de collection.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[une voiture||une voiture de collection||Liv||à tout prix]",
    "correct_answer": "[2||4]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Voici un groupe nominal et deux schémas possibles pour le représenter. Choisissez le schéma qui correspond le mieux au sens du groupe.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Un vélo de course pour les vacances      ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[[[X de Y] pour Z]||[X de [Y pour Z]]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le chat de la voisine de mon père",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X de [Y de Z]]||[[X de Y]  de Z]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Une pièce de rechange de l'ordinateur",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X de [Y de Z]]||[[X de Y] de Z]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Un fer à repasser de compétition",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X à [Y de Z]]||[[X à Y] de Z]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 « Vers pour le portrait de M. Daumier »",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X pour [Y de Z]]||[[X pour Y] de Z]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 « La servante au grand cœur dont vous étiez jalouse »",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X au [Y dont Z]]||[[X au Y] dont Z]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L'escalier de service du dernier étage",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X de [Y de Z]]||[[X de Y] de Z]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La portière de la calèche de Homais",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X de [Y de Z]]||[[X de Y] de Z]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le système d'exploitation pour smartphone",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X de [Y pour Z]]||[[X de Y] pour Z]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le fiancé du capitaine de corvette",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[[X de [Y de Z]]||[[X de Y] de Z]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Voici une phrase suivie d’un groupe de mots. Choisissez parmi les quatre questions celle à laquelle on peut répondre par ce groupe (plusieurs choix sont parfois possibles).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Manon a lu un livre de science-fiction en trois jours.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : de science-fiction",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 1,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[Qui a lu un livre de science-fiction en trois jours ?||Quel type de livre Manon a-t-elle lu en trois jours?||Qu'est-ce que Manon a lu en trois jours?||Qu'est-ce que Manon a fait en trois jours?]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Manon a lu un livre de science-fiction en trois jours.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : un livre de science-fiction",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 2,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Qui a lu un livre de science-fiction en trois jours ?||Quel type de livre Manon a-t-elle lu en trois jours ?||Qu'est-ce que Manon a lu en trois jours ?||Qu'est-ce que Manon a fait en trois jours ?]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Ma voisine m'a parlé hier d'un voyage au Maroc.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : d'un voyage au Maroc",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 3,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[De quoi ma voisine m'a-t-elle parlé hier ?||Où ma voisine m'a-t-elle parlé hier ?||De quel voyage m'a parlé ma voisine hier ?||Qui m'a parlé hier ?]",
    "correct_answer": "[1||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L'ami de Marwane a lu un livre de Stendhal.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 4,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : Stendhal",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 4,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[De qui l'ami de Marwane a-t-il lu un livre ?||L'ami de Marwane a-t-il lu un livre ?||Qu'a lu l'ami de Marwane ?||L'ami de Marwane a lu un livre de qui ?]",
    "correct_answer": "[1||4]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Tien a trouvé ce roman bizarre.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : bizarre",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 5,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Comment Tien a-t-il trouvé ce roman ?||Tien a trouvé quoi bizarre ?||Qu'est-ce queTien a trouvé bizarre ?||Tien a trouvé ce roman comment?]",
    "correct_answer": "[1||4]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Alice voudrait lire ce roman ce week-end.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : lire ce roman",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 6,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Que voudrait faire Alice ce week-end ?||Qu'est-ce que voudrait Alice ce week-end ?||Qu'est-ce que Alice voudrait lire ce week-end ?||Que voudrait lire Alice ce week-end ?]",
    "correct_answer": "[1||2]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Anton est devenu végétarien après avoir vu ce film.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : végétarien",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 7,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Qu'est-ce que Anton est devenu après avoir vu ce film ?||Qu'est devenu Anton après son voyage de noces ?||Après quoi Anton est-il devenu végétarien ?||Anton est devenu végétarien après avoir vu quoi ?]",
    "correct_answer": "[1||2]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Anton est devenu végétarien après avoir vu ce film.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : après avoir vu ce film",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 8,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Qu'est-ce qu’Anton est devenu après avoir vu ce film ?||Qu'est devenu Anton après son voyage de noces ?||Après quoi Anton est-il devenu végétarien ?||Anton est devenu végétarien après avoir vu quoi ?]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Liv cherche depuis longtemps à acheter une voiture de collection.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : une voiture de collection",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 9,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Que cherche à acheter depuis longtemps Liv ?||Qu'est-ce que Liv cherche à acheter depuis longtemps ?||Que cherche Liv ?||Depuis quand Liv cherche-t-elle à acheter une voiture de collection ?]",
    "correct_answer": "[1||2]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Un humain rêve le plus souvent d'un autre humain.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 10,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Réponse fragmentaire : d'un autre humain",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "exercice": 10,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[De quoi un humain rêve-t-il le plus souvent ?||De quoi rêve le plus souvent un humain ?||Un humain rêve le plus souvent de quoi ?||Qui rêve le plus souvent d'un autre humain ?]",
    "correct_answer": "[1||2||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Dans chaque groupe de mots, quel mot détermine le genre et le nombre des autres ?",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 les grands espaces verts",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[les||grands||espaces||verts]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 tous ces énormes problèmes",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[tous||ces||énormes||problèmes]",
    "correct_answer": "4"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 quel superbe accueil chaleureux",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[quel||superbe||accueil||chaleureux]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 jeunes enthousiastes et compétents",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[jeunes||enthousiastes||et||compétents]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 quelques questions toutes simples",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[quelques||questions||toutes||simples]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 un insaisissable malaise persistant",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[un||insaisissable||malaise||persistant]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 le vieil instrument usé",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le||vieil||instrument||usé]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 homme libre et valeureux",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[homme||libre||et||valeureux]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 ces incroyables grands mammifères",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[ces||incroyables||grands||mammifères]",
    "correct_answer": "4"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 toute autre utilisation inappropriée",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[toute||autre||utilisation||inappropriée]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Pour chaque phrase, choisissez la version réduite qui en conserve les éléments fondamentaux. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Ma tante Marguerite et mon oncle Gaston qui faisaient avec leurs enfants une saison à Cauterets nous invitèrent, ma sœur et moi, à les y rejoindre. (Simone de Beauvoir)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Ma tante et mon oncle faisaient une saison à Cauterets.||Ma tante et mon oncle faisaient une saison à Cauterets et nous invitèrent.||Ma tante et mon oncle nous invitèrent à les y rejoindre.]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Françoise, qui était depuis des années à son service et ne se doutait pas alors qu’elle entrerait un jour tout à fait au nôtre, délaissait un peu ma tante pendant les mois où nous étions là. (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Françoise délaissait ma tante.||Françoise était à son service.||Elle entrerait au nôtre.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Maman qui savait que Françoise pleurait encore ses parents morts depuis des années, lui demandait mille détails sur ce qu’avait été leur vie.  (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Maman savait que Françoise pleurait.||Françoise pleurait encore ses parents.||Maman lui demandait mille détails.]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 L’ignorance où nous étions de cette brillante vie mondaine que menait Swann tenait évidemment en partie à la réserve et à la discrétion de son caractère. (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[L’ignorance où nous étions menait Swann.||L’ignorance tenait à la réserve et à la discrétion de son caractère.||L’ignorance tenait de son caractère.]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Déguisée en chaperon rouge, portant dans mon panier galette et pot de beurre, je me sentais plus intéressante qu’un nourrisson cloué dans son berceau.  (Simone de Beauvoir)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Déguisée en chaperon rouge.||Un nourrisson cloué dans son berceau.||Je me sentais intéressante.]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Souple, d’articulation aussi puissante, aussi royale d’attitude, la femme, l’inconnue, était comme une panthère humaine, dressée devant la panthère animale qu’elle éclipsait. (Barbey d’Aurevilly)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[L’inconnue était dressée devant la panthère qu’elle éclipsait.||La femme était comme une panthère humaine.||La femme était dressée devant la panthère animale.]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le vicomte de Brassard était donc, à la minute où je montai dans la diligence de ***, ce que le monde, féroce comme une jeune femme, appelle malhonnêtement un « vieux beau ». (Barbey d’Aurevilly)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Le vicomte de Brassard était ce que le monde appelle « un vieux beau ». ||Je montai dans la diligence de ***.||Le monde, féroce comme une jeune femme, l’appelle malhonnêtement un « vieux beau ».]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Au milieu des énormes moellons qui gisaient là et des constructions qui s’y élevaient, une seule maison restée debout sur sa base, sans voisines, étroite, laide, rechignée, tremblante, se dressait, d’un noir plus sombre, dans un ciel déjà noir. (Barbey d’Aurevilly)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Au milieu des énormes moellons qui gisaient là et des constructions qui s’y élevaient.||Une seule maison se dressait.||Une seule maison restée debout sur sa base se dressait dans un ciel déjà noir.]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Quand, au moment de quitter l’église, je m’agenouillai devant l’autel, je sentis tout d’un coup, en me relevant, s’échapper des aubépines une odeur amère et douce d’amandes. (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Je sentis s’échapper des aubépines une odeur amère et douce d’amandes.||Je m’agenouillai devant l’autel.||Je sentis tout d’un coup.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Trois semaines après son départ, comme je traversais la place de la Sorbonne, j’aperçus devant la terrasse du d’Harcourt son auto. (Simone de Beauvoir)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Trois semaines après son départ, j’aperçus devant la terrasse du d’Harcourt son auto.||Comme je traversais la place de la Sorbonne, j’aperçus son auto.||J’aperçus son auto.]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Par quel pronom peut-on remplacer le groupe de mots @en gras@ ? (Dans certains cas, le pronom occupe une place différente dans la phrase ainsi obtenue.)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Marie mange @la glace à la fraise de Paul@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[la||elle||en]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 @La dame qu’accompagnait Legrandin@ était une personne vertueuse et considérée. (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[la||elle||ce]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mon grand-père était curieux de @tous les petits faits qui pouvaient l’aider à entrer dans la vie privée d’hommes comme le duc de Broglie@.\n(Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le||il||en]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Ma grand-mère avait trouvé @ces gens@ parfaits. (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[en||les||ils]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Ma mère fit remarquer @qu’il avait l’air bien moins triste@. (Proust)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le||y||en]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 @Son regard tranquille@ me protégeait pendant que je berçais ma poupée Blondine. (Maupassant)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[elle||il||on]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Lina a été @médecin@ pendant 7 ans.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[lui||il||l']",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Un jour il rêva @qu’il partait pour un an@. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[en||le||ce]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 J’étouffais un peu @dans cette salle à manger plus encombrée qu’une arrière-boutique d’antiquaire@. (Simone de Beauvoir)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[en||l'||y]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Je retrouvai dans les jardins du Luxembourg @l’odeur et les rousseurs de l’automne@. (Simone de Beauvoir)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[y||les||la]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Choisissez le mot ou le groupe de mots qui, pour le sens, est le sujet du verbe @en gras@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Le nouvel enseignant de Myriam qui m’a fait comprendre les mathématiques @chante@ dans une chorale.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Myriam||le nouvel enseignant de Myriam||les mathématiques]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Ce voyageur enveloppé d'un ample manteau qui couvrait la croupe de son cheval @s'étonna@ de s'en sortir si bien. (D’après Hugo, $Quatrevingt-Treize$)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Ce voyageur enveloppé d'un ample manteau qui couvrait la croupe de son cheval||un ample manteau qui couvrait la croupe de son cheval||son cheval]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Son attention, alors qu'elle traversait avec précaution la lande qui s'étendait devant sa maison, @venait@ d'être brusquement réveillée. (D’après Hugo, $Quatrevingt-Treize$)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[son attention||elle||sa maison]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le comte du Boisberthelot et le chevalier de La Vieuville reconduisirent l'homme aux habits de paysan jusqu'à sa cabine qui @étonna@ le vieux capitaine. (D’après Hugo, $Quatrevingt-Treize$)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le comte de Boisberthelot||le chevalier de La Vieuville||sa cabine]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Sa robe noire, dont la coupe, s'élargissant en éventail, l'amincissait, mettait en valeur sa silhouette et la @rendait@ plus grande. (D’après Zola)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[sa robe noire||la coupe||sa silhouette]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La Vendée, en démontrant la nécessité de trouer dans tous les sens la vieille ombre bretonne et de percer cette broussaille de toutes les flèches de la lumière à la fois, @a servi@ le progrès. (D’après Hugo, $Quatrevingt-Treize$)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[La Vendée||la vieille ombre bretonne||cette broussaille]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le vaisseau du capitaine de l'escadron n'avait pas de feu à l'avant, de crainte qu'il @ne dénonce@ son passage dans ces mers surveillées. (D’après Zola)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[Le vaisseau du capitaine de l'escadron||l'escadron||le feu]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Il a un fils, qui est républicain, et, pendant que le père, impressionné par le seigneur local, @sert@ dans les blancs, le fils sert dans les bleus. (D’après Zola)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[un fils||le père||le seigneur local]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le fils aîné du cousin de mon père @est retourné@ vivre dans notre village d’origine.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le fils aîné||le cousin||mon père]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Au bout de ce couloir, le petit bureau qui donne sur le salon @reçoit@ une belle lumière grâce à une fenêtre orientée sud. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[ce couloir||le petit bureau||le salon]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Par quel pronom peut-on remplacer le groupe de mots @en gras@ ? (Dans certains cas, le pronom occupe une place différente dans la phrase ainsi obtenue.)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Je crois @que Pauline est honnête@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 1,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[la||le||y]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Je crois @Pauline@ honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[la||le||y]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Je crois @au bénéfice de dormir deux heures@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[la||le||y]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Je crois @avoir dormi deux heures en tout@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[la||le||y]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Je rêve @que je mange du chocolat@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le||y||en]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Je rêve @de manger du chocolat@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[le||y||en]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 J'ai rêvé @de mon voisin Totoro@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[l'||en||lui]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Il a pensé @à son voisin Totoro@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[l'||en||y]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Il a pensé @que son voisin Totoro était sympathique@. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[y||lui||l']",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Il a pensé du bien @de son voisin Totoro@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[y||en||l’]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Voici un mot qui peut avoir plusieurs natures grammaticales. Indiquez quelle est cette nature dans le contexte proposé.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : voyage",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Contexte : Qui voyage les yeux ouverts n'a pas besoin de\nvalises.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 1,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[verbe||nom]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : presses",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Tu n'obtiendras rien si tu presses les gens.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 2,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[verbe||nom]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : la",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Ce sont les grands journaux qui donnent le la.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 3,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[article||nom]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : mousse",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 4,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Pierre qui roule n'amasse pas mousse.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 4,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[verbe||nom]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : contre",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : On m'a demandé de peser le pour et le contre.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 5,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[nom||préposition]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : vote",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : C'est un vote obtenu sous la contrainte.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 6,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[verbe||nom]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : danse",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Les danseurs transposent le désir de liberté\ninhérent à toute danse.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 7,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[nom||verbe]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : parti",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Tout semble parti en fumée.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 8,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[nom||verbe]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : parti",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Il semble un parti honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 9,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[nom||verbe]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot : basse",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 10,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Contexte : Il a une voix de basse.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "exercice": 10,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[nom||adjectif]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Chaque groupe nominal ou phrase ci-dessous peut avoir deux interprétations. Choisissez le regroupement de mots qui convient à l’interprétation donnée. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 la fille de la voisine qui a beaucoup voyagé",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : La voisine a une fille. Cette fille a beaucoup voyagé.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 1,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[[[la fille de la voisine] qui a beaucoup voyagé]||[la fille de [la voisine qui a beaucoup voyagé]]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 le prétendant de la jeune fille avec des gants blancs",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Une jeune fille avec des gants blancs a un prétendant.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 2,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[[le prétendant de [la jeune fille avec des gants blancs]]||[[le prétendant de la jeune fille] avec des gants blancs]]]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 l'enfant à lunettes effrayant tout le monde",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Il y a un enfant qui porte des lunettes. Cet enfant effraie tout le monde.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 3,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[[l'enfant à [lunettes effrayant tout le monde]]||[[l'enfant à lunettes] effrayant tout le monde]]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Il est interdit de consommer les produits achetés à l'intérieur de la cafétéria.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 4,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Les produits achetés ne peuvent pas être consommés à l'intérieur de la cafétéria.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 4,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Il est interdit de [consommer [les produits achetés à l'intérieur de la cafétéria]].||Il est interdit de [[consommer les produits achetés] à l'intérieur de la cafétéria].]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La fille regarde le garçon avec le télescope.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Le garçon porte un télescope.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 5,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[La fille [[regarde le garçon] avec le télescope].||La fille [regarde [le garçon avec le télescope]].]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 On a joué avec le fils de notre ami qui est aveugle.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Notre ami a un fils. Ce fils est aveugle.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 6,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[On a joué avec [le fils de [notre ami qui est aveugle]].||On a joué avec [[le fils de notre ami] qui est aveugle].]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Tante Clara nous a rapporté un vase de Chine.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Tante Clara nous a apporté un vase de porcelaine.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 7,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Tante Clara nous a [rapporté [un vase de Chine]].||Tante Clara nous a [[rapporté un vase] de Chine].]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Les filles de la classe aiment toutes les sciences.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : La totalité des filles de la classe aime les sciences. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 8,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Les filles de la classe [aiment [toutes les sciences]].||Les filles de la classe [aiment toutes [les sciences]].]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La cigale chante l’été.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Le chant de la cigale est une ode à l’été.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 9,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[La cigale [chante l’été].||La cigale [chante [l’été]].]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Un matin, j’ai tiré sur un éléphant en pyjama. (Groucho Marx)",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 10,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétration choisie : Un matin, encore en pyjama, j’ai tiré sur un éléphant.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "exercice": 10,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Un matin, j’ai [tiré sur [un éléphant en pyjama]].||Un matin, j’ai [[tiré sur un éléphant] en pyjama].]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Chacune de ces phrases a deux interprétations possibles, qui dépendent de la nature grammaticale donnée aux mots. Choisissez celle des deux interprétations qui correspond aux choix grammaticaux donnés.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "🤔 La belle ferme le voile.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : La ($det$) belle ($nom$) ferme ($verbe$) le ($det$) voile ($nom$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 1,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[La belle femme ferme son voile.||Le beau bâtiment agricole le cache.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le boucher sale la tranche.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : Le ($det$) boucher ($nom$) sale ($verbe$) la ($det$) tranche ($nom$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 2,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Le boucher met du sel sur la tranche.||Le boucher est sale, et tranche quelque chose.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le grand vide le comble. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : Le ($det$) grand ($nom$) vide ($verbe$) le ($det$) comble ($nom$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 3,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Le vide, qui est grand, comble quelque chose ou quelqu'un (dont on vient de parler).||Une personne de grande taille vide le grenier.]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La petite fête l’abîme.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 4,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : La ($det$) petite ($adj$) fête ($nom$) l' ($pronom$) abîme ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 4,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Il y a une petite fête, qui abîme quelque chose (dont on vient de parler).||Il y a une petite, qui fête un abîme.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La grande annonce la presse. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : La ($det$) grande ($adj$) annonce ($nom$) la ($pronom$) presse ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 5,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Une femme, qui est grande, annonce la presse.||Une annonce, qui est grande, presse quelque chose ou quelqu'un (dont on vient de parler).]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La vieille limite la menace.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : La ($det$) vieille ($adj$) limite ($nom$) la ($pronom$) menace ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 6,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[La limite, qui est ancienne, menace quelque chose ou quelqu'un (dont on vient de parler).||Une personne âgée amoindrit la menace.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Cette vieille pratique l’attaque. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : Cette ($det$) vieille ($adj$) pratique ($nom$) l' ($pronom$) attaque ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 7,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Cette pratique, qui est ancienne, attaque quelque chose ou quelqu'un (dont on vient de parler).||Cette personne âgée a l'habitude d'attaquer.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le vieux lit le trouble. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : Le ($det$) vieux ($adj$) lit ($nom$) le ($pronom$) trouble ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 8,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Le lit ancien trouble quelque chose ou quelqu'un (dont on vient de parler).||La vieille personne perçoit le trouble.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La jeune garde la fabrique.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : La ($det$) jeune ($adj$) garde ($nom$) la ($pronom$) fabrique ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 9,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Une personne jeune garde une usine.||La garde, qui est jeune, fabrique quelque chose (dont on vient de parler).]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le jeune ménage la finance. ",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 10,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Choix grammaticaux : Le ($det$) jeune ($adj$) ménage ($nom$) la ($pronom$) finance ($verbe$).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "exercice": 10,
    "content_id": 2,
    "type": "qcm",
    "format": "text",
    "content": "[Un ménage, jeune, finance quelque chose ou quelqu'un (dont on vient de parler).||Une personne jeune a tendance à préserver la finance.]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Voici une phrase contenant un mot @en gras@, ainsi que deux interprétations possibles. Parmi ces trois catégories d’ambiguïté, choisis celle qui permet de distinguer les deux interprétations.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Ambiguïté de nature : donner la nature (grammaticale) du mot permet de lever l’ambiguïté.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Ambiguïté de rattachement : dire à quoi se rattache le mot permet de lever l’ambiguïté.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 3,
    "type": "message",
    "format": "text",
    "content": "Ambiguïté lexicale : le mot est dans les deux cas de même nature, mais de sens différent.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 4,
    "type": "message",
    "format": "text",
    "content": "🤔 Cet avocat est @véreux@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 5,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Cet homme, qui est avocat, est malhonnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 6,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : Ce fruit de l'avocatier est pourri.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 1,
    "content_id": 7,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le nouveau @juge@ la commande.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 2,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Il y a un nouveau, qui juge la commande.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 2,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : Le juge récemment nommé commande quelque chose ou quelqu'un (dont on vient de parler).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 2,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Paul parle avec la fille @du@ voisin.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 3,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Paul parle du voisin avec la fille.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 3,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : Paul parle avec la fille, qui est la fille du voisin.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 3,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Quelqu'un a @volé@ dans la salle.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 4,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Dans la salle, il y a quelqu'un qui a volé quelque chose.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 4,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : Dans la salle, il y a quelqu'un qui a volé dans les airs.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 4,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La classe @comprend@ trois parties.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 5,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : La classe a une bonne compréhension de trois parties (de programme).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 5,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : La classe est composée de trois parties.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 5,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Le grand lit @la@ gêne chez eux.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 6,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Il y a un grand, qui perçoit chez eux une gêne.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 6,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : Chez eux, il y a un lit qui la gêne.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 6,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Pauline a entendu la chute @du@ balcon.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 7,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Pauline a entendu le balcon chuter.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 7,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : C'est depuis le balcon que Pauline a entendu la chute (de qqch).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 7,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La juge a @cru@ cet homme honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 8,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : La juge a cru ce que disait cet homme, qui est honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 8,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : La juge a cru que cet homme était honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 8,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 La juge a cru cet homme @honnête@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 9,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : La juge a cru ce que disait cet homme, qui est honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 9,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : La juge a cru que cet homme était honnête.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 9,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Pauline pensait avoir été éloquente @hier@.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 10,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Interprétation 1 : Hier, Pauline pensait qu'elle avait été éloquente (mais elle ne le pense plus forcément).",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 10,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Interprétation 2 : Pauline pensait qu'hier elle avait été éloquente.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "exercice": 10,
    "content_id": 3,
    "type": "qcm",
    "format": "text",
    "content": "[ambiguïté de nature||ambiguïté de rattachement||ambiguïté lexicale]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "📖 Les mots $en italique$ de ce poème de Lewis Caroll (trad. H. Parisot) sont des mots inventés, mais ils sont employés de manière à former des phrases syntaxiquement correctes. Indiquez la nature grammaticale de chacun de ces mots.",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 1,
    "type": "message",
    "format": "text",
    "content": "Poème :",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 2,
    "type": "message",
    "format": "text",
    "content": "Il était $grilheure$ ; les $slictueux$ $toves$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 3,
    "type": "message",
    "format": "text",
    "content": "Sur l’$alloinde$ $gyraient$ et $vriblaient$ ;",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 4,
    "type": "message",
    "format": "text",
    "content": "Tout $flivoreux$ étaient les $borogoves$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 5,
    "type": "message",
    "format": "text",
    "content": "Les $vergons$ $fourgus$ bourniflaient",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 6,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $grilheure$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 1,
    "content_id": 7,
    "type": "qcm",
    "format": "text",
    "content": "[nom||adverbe||verbe]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 2,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $slictueux$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 2,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[adjectif||nom||adverbe]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 3,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $toves$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 3,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[adjectif||nom||verbe]",
    "correct_answer": "2"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 4,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $alloinde$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 4,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[adverbe||adjectif||nom]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 5,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $gyraient$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 5,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[verbe||adjectif||nom]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 6,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $vriblaient$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 6,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[nom||adverbe||verbe]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 7,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $flivoreux$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 7,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[adjectif||adverbe||nom]",
    "correct_answer": "1"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 8,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $borogoves$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 8,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[verbe||adjectif||nom]",
    "correct_answer": "3"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 9,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $vergons$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 9,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[nom||verbe||adjectif]",
    "correct_answer": "[1||3]"
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 10,
    "content_id": 0,
    "type": "message",
    "format": "text",
    "content": "🤔 Mot inconnu : $fourgus$",
    "correct_answer": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "exercice": 10,
    "content_id": 1,
    "type": "qcm",
    "format": "text",
    "content": "[nom||adjectif||adverbe]",
    "correct_answer": "[1||2]"
  }
 ];